import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button } from '@mui/material'

import { FormSubmitButton, HelperWrapper } from 'src/components'
import { MobileBottomLayout } from 'src/components/mobile-bottom-layout'

import useStyles from './styles'
import { createRelativePath } from 'src/common/utils'

interface IProps {
  isDisabled?: boolean
}

const MobileNewButtons = ({ isDisabled }: IProps) => {
  const [t] = useTranslation()
  const navigate = useNavigate()
  const classes = useStyles()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const duplicate = searchParams.get('duplicate')
  const libraryDuplicate = searchParams.get('libraryDuplicate')

  const handleDiscard = () => navigate(createRelativePath(location))

  return (
    <MobileBottomLayout isFixed>
      <Button
        disabled={isDisabled}
        variant="contained"
        onClick={handleDiscard}
        className={`${classes.formButton} ${classes.formButtonLight}`}
      >
        <HelperWrapper t="discard-button-text" isColorInherited />
      </Button>
      <FormSubmitButton
        disabled={isDisabled}
        notDisabledIfDirty={!!duplicate || !!libraryDuplicate}
        withoutIcon
        validText={t('save-button-text.v')}
        invalidText={t('save-button-text.v')}
      />
    </MobileBottomLayout>
  )
}

export { MobileNewButtons }
